const TITLE_SEPARATORS = [' — ', ' - '];

function truncateTitle(value: string, maxLength: number): string {
  if (value.length <= maxLength) {
    return value;
  }

  const extensionMatch = value.match(/(\.[^.]+)$/);
  const extension = extensionMatch?.[1] ?? '';
  const baseName = extension ? value.slice(0, -extension.length) : value;
  const allowedBaseLength = maxLength - extension.length - 1;

  if (allowedBaseLength <= 3) {
    return `${value.slice(0, maxLength - 1)}…`;
  }

  return `${baseName.slice(0, allowedBaseLength)}…${extension}`;
}

export function formatDocumentTitle(
  titulo?: string | null,
  maxLength = 48
): string {
  if (!titulo) {
    return 'Sem título';
  }

  for (const separator of TITLE_SEPARATORS) {
    if (titulo.includes(separator)) {
      const parts = titulo.split(separator);
      const fileName = parts[parts.length - 1]?.trim();
      if (fileName) {
        return truncateTitle(fileName, maxLength);
      }
    }
  }

  return truncateTitle(titulo, maxLength);
}
